import { useQuery, useMutation, useQueryClient } from 'react-query';
import { apiService } from '../services/api';
import { LogsCleanupSettings, LogsCleanupSettingsUpdate } from '../types';
import toast from 'react-hot-toast';

export const useLogsCleanupSettings = () => {
  const queryClient = useQueryClient();

  // Получение настроек очистки логов
  const { 
    data: settings, 
    isLoading, 
    error 
  } = useQuery(
    'logs-cleanup-settings',
    () => apiService.getLogsCleanupSettings(),
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  );

  // Обновление настроек очистки логов
  const { 
    mutate: saveSettings, 
    isLoading: isSaving 
  } = useMutation(
    (settings: LogsCleanupSettingsUpdate) => apiService.updateLogsCleanupSettings(settings),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries('logs-cleanup-settings');
        toast.success(data.message || 'Настройки очистки логов сохранены!');
      },
      onError: (error: any) => {
        toast.error(error.detail || 'Ошибка при сохранении настроек очистки логов');
      }
    }
  );

  // Запуск очистки логов
  const { 
    mutate: runCleanup, 
    isLoading: isRunningCleanup 
  } = useMutation(
    () => apiService.runLogsCleanup(),
    {
      onSuccess: (data) => {
        toast.success(`${data.message} Удалено: ${data.deleted_action_logs} логов действий тренеров`);
      },
      onError: (error: any) => {
        toast.error(error.detail || 'Ошибка при выполнении очистки логов');
      }
    }
  );

  return {
    settings,
    isLoading,
    error,
    saveSettings,
    isSaving,
    runCleanup,
    isRunningCleanup
  };
}; 